import { getAlpha3Codes } from 'i18n-iso-countries';
import { AppLanguage, cities, Currency, EnvName } from 'types/general';

const alpha3 = Object.keys(getAlpha3Codes());
const envName: EnvName =
  process.env.NODE_ENV === 'test'
    ? 'test'
    : (process.env.REACT_APP_ENV_NAME as EnvName) || 'localhost';

const HOST_BY_ENV: Record<EnvName, string> = {
  test: 'http://localhost:3000',
  localhost: 'http://localhost:3000',
  uat: 'https://hr.uat.melp.com',
  prod: 'https://hr.melp.com',
};

const HOST_MELP_API_BY_ENV: Record<EnvName, string> = {
  test: 'https://api.uat.melp.com',
  localhost: 'https://api.uat.melp.com',
  uat: 'https://api.uat.melp.com',
  prod: 'https://api.melp.com',
};

const COGNITO_DOMAIN_BY_ENV: Record<EnvName, string> = {
  test: 'test',
  localhost: 'uat-melp.auth.eu-west-1.amazoncognito.com',
  uat: 'uat-melp.auth.eu-west-1.amazoncognito.com',
  prod: 'auth-admin.services.melp.com',
};

const DYNAMIC_LINKKS_BASE_URL_BY_ENV: Record<EnvName, string> = {
  test: 'https://scmfu.test-app.link',
  localhost: 'https://scmfu.test-app.link',
  uat: 'https://scmfu.test-app.link',
  prod: 'https://scmfu.app.link',
};

export const APP = {
  envName,
  name: 'MELP',
  host: {
    client: HOST_BY_ENV[envName],
    api: process.env.REACT_APP_API_URL,
    melpApi: HOST_MELP_API_BY_ENV[envName],
  },
  email: {
    info: 'info@melp.com',
  },
  layout: {
    container: {
      maxWidth: 1350,
    },
  },
  locales: {
    default: 'en',
  } satisfies { default: AppLanguage },
  dynamicLinks: {
    baseUrl: DYNAMIC_LINKKS_BASE_URL_BY_ENV[envName],
    path: 'redirect',
  },
  countries: {
    alpha3,
    default: 'LTU',
  },
  currencies: {
    default: 'EUR',
  } satisfies { default: Currency },
  cities,
  pagination: {
    defaults: {
      pageSize: [100, 150, 200],
    },
  },
  env: process.env.REACT_APP_ENV_NAME,
  cognito: {
    region: process.env.REACT_APP_AWS_COGNITO_REGION,
    poolId: process.env.REACT_APP_AWS_USER_POOLS_ID,
    webClientId: process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID,
    domain: COGNITO_DOMAIN_BY_ENV[envName],
  },
  sentry: {
    dsn: 'https://f46106aa6e664b9b9893f2c19e8db899@o4504339175112704.ingest.sentry.io/4504367637397504',
  },
  hotjar: {
    siteId: Number(process.env.REACT_APP_HOTJAR_SITE_ID),
    version: Number(process.env.REACT_APP_HOTJAR_VERSION),
  },
} as const;
